import { render, staticRenderFns } from "./BrandComponentPrices.vue?vue&type=template&id=a0e4cd5a&scoped=true"
import script from "./BrandComponentPrices.vue?vue&type=script&lang=js"
export * from "./BrandComponentPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e4cd5a",
  null
  
)

export default component.exports